<template>
  <div class="bg-circle">
    <contact-faq-header :header-text="page.title" :image="page.active_image">
      <div class="prose content" v-html="page.template.tekst"/>
    </contact-faq-header>

    <nuxt-child :key="$route.params.slug"/>
  </div>
</template>

<script>
import page from '~/plugins/mixins/page';
import ContactFaqHeader from '~/components/headers/ContactFaqHeader';

export default {
  components: {ContactFaqHeader},
  mixins: [page],
  // used to overwrite page mixin fetch, since route is not usable for the call because of nuxt-child
  async fetch({store, error}) {
    try {
      await store.dispatch('getPage', 'vragen');
    } catch (e) {
      const statusCode = e.response && e.response.status >= 500 ? 503 : 404;

      error({statusCode, message: e.message});
    }
  },
};
</script>
